const sortColumnOptions = [
  { label: "Timestamp", value: "DCID" },
  { label: "Policy Number", value: "PolicyNumber" },
  { label: "Product", value: "ProductCode" },
  { label: "Registration Number", value: "RegNumber" },
  { label: "Plate Number", value: "PlateNumber" },
  { label: "Insured", value: "InsuredName" },
  { label: "Transaction Date", value: "EntryDateTime" },
];

export default sortColumnOptions;
